var _path, _path2, _mask, _ellipse, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 133,
    viewBox: "0 0 133 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 128.5C100.742 128.5 128.5 100.742 128.5 66.5C128.5 32.2583 100.742 4.5 66.5 4.5C32.2583 4.5 4.5 32.2583 4.5 66.5C4.5 100.742 32.2583 128.5 66.5 128.5Z",
    stroke: "#E0E0E0",
    strokeWidth: 8,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5 41.7C70.5 39.4908 68.7091 37.7 66.5 37.7C64.2909 37.7 62.5 39.4908 62.5 41.7H70.5ZM62.5 66.5C62.5 68.7091 64.2909 70.5 66.5 70.5C68.7091 70.5 70.5 68.7091 70.5 66.5H62.5ZM62.5 41.7V66.5H70.5V41.7H62.5Z",
    fill: "#E0E0E0"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_820_11911",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.8797,
    cy: 93.7793,
    rx: 6.2,
    ry: 6.2
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.8797,
    cy: 93.7793,
    rx: 6.2,
    ry: 6.2,
    fill: "#E0E0E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0797 93.7793C65.0797 93.3375 65.4379 92.9793 65.8797 92.9793V106.979C73.1698 106.979 79.0797 101.07 79.0797 93.7793H65.0797ZM65.8797 92.9793C66.3215 92.9793 66.6797 93.3375 66.6797 93.7793H52.6797C52.6797 101.07 58.5895 106.979 65.8797 106.979V92.9793ZM66.6797 93.7793C66.6797 94.2212 66.3215 94.5793 65.8797 94.5793V80.5793C58.5895 80.5793 52.6797 86.4892 52.6797 93.7793H66.6797ZM65.8797 94.5793C65.4379 94.5793 65.0797 94.2212 65.0797 93.7793H79.0797C79.0797 86.4892 73.1698 80.5793 65.8797 80.5793V94.5793Z",
    fill: "#E0E0E0",
    mask: "url(#path-3-inside-1_820_11911)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.7670a1e0d98aed8a39ae374d6678314c.svg";
export { ForwardRef as ReactComponent };